/**
 * Safari Video Fix
 * Simple script to ensure autoplay videos play in Safari
 */

export function initSafariVideoFix() {
    // Play all videos with autoplay attribute
    document.addEventListener('DOMContentLoaded', function() {
        const videos = document.querySelectorAll('video[autoplay]');        
        videos.forEach(function(video) {
            video.play();
        });
    });
}